import { Injectable } from '@angular/core';
import { Player } from 'fl-player-interface';
import { ResourceVm } from 'qp-ui-interface';

@Injectable({
  providedIn: 'root',
})
export class DatazoomService {
  // private appSession: ApplicationSession;
  // private playbackSession: PlaybackSession;
  // private userSession: UserSession;
  // private playbackContent: Content;
  // private playbackContainer: ApplicationContainer;
  // private playbackSource: string;

  // constructor(private configService: ConfigService, private readonly deviceHandler: DeviceHandlerService) { }

  /**
   * Triggered when the app is initialized
   * @returns void
   */
  async init() {
    //   datazoom.setLogLevel("verbose");
    //   this.appSession = getApplicationSession();
    //   const config: DatazoomAnalyticsReporterConfiguration = {
    //     configId: this.getDatazoomKey(),
    //     application: getApplicationInfo(),
    //     device: getDeviceInfo(this.deviceHandler),
    //     user: getUserInfo(),
    //     customEventsConfigUrl: this.configService.applicationConfig.datazoomCustomEventsConfigUrl,
    //     // logger: createLogger(LoggerLevel.VERBOSE, '[DZ]')
    //  };
    //   await this.appSession.initialize(config);
    //   this.updateMetadata();
    //   this.appSession.start();
    //   this.userSession = this.appSession.createUserSession(getUserInfo());
  }

  /**
   * Triggered when the app is stopped
   */
  stop() {
    // this.appSession.stop();
  }

  updateMetadata() {
    // this.appSession.setMetadata({
    //   'profile_type': getProfileType(),
    // });
  }

  /**
   * Create playback session to track analytics
   *
   * @param resourceVm
   * @param source
   */
  createPlaybackSession(_: ResourceVm, _1: string) {
    // try {
    //   if (this.playbackSession) return; // not create if already exists
    //   let content = getContentFromResource(resourceVm);
    //   this.playbackContent = content;
    //   this.playbackContainer = getApplicationContainer(resourceVm);
    //   this.playbackSource = source;
    //   this.playbackSession = this.appSession.createPlaybackSession(this.playbackContent, this.playbackSource, this.playbackContainer);
    //   this.playbackSession.start();
    // } catch (error) {
    //   console.error('[DZ] Error creating playback session', error);
    // }
  }

  /**
   * Triggered when the player is loaded
   *
   * @param resourceVm
   * @param playerInstance
   */
  attachPlayer(_: Player) {
    // if (this.playbackSession) {
    //   this.playbackSession.attachPlayer(playerInstance);
    // }
  }

  /**
   * Triggered when the player is stopped
   */
  stopPlaybackSession() {
    // if (this.playbackSession) {
    //   this.playbackContainer = null;
    //   this.playbackContent = null;
    //   this.playbackSource = null;
    //   this.playbackSession.stop();
    //   this.playbackSession = null;
    // }
  }

  /**
   * Triggered when the player is stopped
   *
   * @param errorCode
   * @param errorDescription
   * @param error
   */
  stopPlaybackSessionWithError(_: string, _1: string, _2: any) {
    // if (this.playbackSession) {
    //   this.playbackSession.stop(getPlaybackError(errorCode, errorDescription, error, this.playbackContent, this.playbackSource, this.playbackContainer));
    //   this.playbackSession = null;
    // }
  }

  /**
   * Triggered when the user logs in
   */
  loginUser() {
    // this.userSession.login(getUserInfo());
  }

  /**
   * Triggered when the user logs out
   */
  logoutUser() {
    // this.userSession.logout();
  }

  /**
   * Triggered when app go to foreground
   */
  reportForeground() {
    // if (getDeviceType() !== DeviceTypeModel.LG) return;
    // if (this.playbackSession) {
    //   this.playbackSession.interruptStart({
    //     event: 'app_foreground',
    //     data: {
    //       'event_type': 'app_foreground'
    //     }
    //   });
    // } else {
    //   this.appSession.interruptStart({
    //     event: 'app_foreground',
    //     data: {
    //       'event_type': 'app_foreground'
    //     }
    //   });
    // }
  }

  /**
   * Triggered when app go to background
   */
  reportBackground() {
    // if (getDeviceType() !== DeviceTypeModel.LG) return;
    // if (this.playbackSession) {
    //   this.playbackSession.interruptEnd({
    //     event: 'app_background',
    //     data: {
    //        'event_type': 'app_background'
    //     }
    //   });
    // } else {
    //   this.appSession.interruptEnd({
    //     event: 'app_background',
    //     data: {
    //       'event_type': 'app_background'
    //     }
    //   });
    // }
  }

  // private getDatazoomKey(): string {
  //     const deviceType = getDeviceType();
  //     switch (deviceType) {
  //         case DeviceTypeModel.VIZIO: return this.configService.applicationConfig.datazoomVizioKey;
  //         case DeviceTypeModel.LG: return this.configService.applicationConfig.datazoomLGKey;
  //         case DeviceTypeModel.SAMSUNG: return this.configService.applicationConfig.datazoomTizenKey;
  //         default: return this.configService.applicationConfig.datazoomTizenKey;
  //     }
  //   }
}
